import { getConfig } from './env-config';

export const APP_ENV = getConfig('REACT_APP_ENV');

export const GRAPHQL_API = getConfig('REACT_APP_FANTASY_GRAPHQL_API');
export const ACCOUNT_SERVICE_API = getConfig('REACT_APP_FANTASY_ACCOUNT_SERVICE_API');
export const RESOURCE_URL = getConfig('REACT_APP_FANTASY_RESOURCE_URL');
export const ADDRESS_EXPLORER_URL = getConfig('REACT_APP_ADDRESS_EXPLORER_URL');
export const TRANSACTION_EXPLORER_URL = getConfig('REACT_APP_TRANSACTION_EXPLORER_URL');
export const MINING_TOOL_RESOURCE_URL = `${RESOURCE_URL}/assets/tools`;
export const LAND_RESOURCE_URL = `${RESOURCE_URL}/assets/lands`;
export const GENE_RESOURCE_URL = `${RESOURCE_URL}/assets/genes`;
export const SLIME_RESOURCE_URL = `${RESOURCE_URL}/assets/slime`;
export const TOOL_MATERIAL_RESOURCE_URL = `${RESOURCE_URL}/assets/tool-materials`;
export const GACHA_BOX_RESOURCE_URL = `${RESOURCE_URL}/assets/gacha-boxes`;
export const SLIME_SKILL_RESOURCE_URL = `${RESOURCE_URL}/assets/slime-skills`;
export const SLIME_SPINE_RESOURCE_URL = `${RESOURCE_URL}/assets/spines/slime`;

export const isShowSaleHistories = getConfig('REACT_APP_IS_SHOW_SALE_HISTORIES') === 'true';
export const isShowDashboardStatistics =
  getConfig('REACT_APP_IS_SHOW_DASHBOARD_STATISTICS') === 'true';

export const isDevelopment = APP_ENV === 'development';
